var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          staticClass: "animated slideInUp",
          attrs: { bottom: "", color: _vm.MsgStatus.color, timeout: 2400 },
          on: { input: _vm.hideMessage },
          model: {
            value: _vm.MsgStatus.show,
            callback: function ($$v) {
              _vm.$set(_vm.MsgStatus, "show", $$v)
            },
            expression: "MsgStatus.show",
          },
        },
        [_vm._v(" " + _vm._s(_vm.MsgStatus.text) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }